import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { characterLimitRangeError, validateCharacterLimit } from '../../../helpers/utils';
import parse from 'html-react-parser';
import { getAlignment, getFontFamily } from '../../../helpers/utils';
import { components } from 'react-select';

const TableElement = ({
  name,
  is_required,
  value,
  defaultValue = '',
  onChange = () => {},
  label,
  type,
  className = '',
  font = null,
  fontFamily,
  is_autofill = false,
  autoFillValue,
  showRequiredError,
  showRequireConfirmationError,
  sub_label = null,
  character_limit = null,
  showCharacterLimitError = false,
  zoom,
  inputFont,
  inputFontFamily,
  alignment,
  width,
  component_color,
  oneLine = false,
  columns,
  height,
  component,
}) => {
  return (
    <TableElementWrapper className={className}>
      <div className="flex-clumn h-full" style={{ backgroundColor: component_color }}>
        <div className="flex flex-1 w-full h-full items-center">
          {columns?.map((column, i) => (
            <Column column={column} key={i} zoom={zoom} component={component} />
          ))}
        </div>
      </div>
    </TableElementWrapper>
  );
};

const Column = ({ column, zoom, component }) => {
  return (
    <div
      className={`flex h-full ${
        column.vertical_align === 'CENTER'
          ? 'items-center'
          : column.vertical_align === 'TOP'
          ? 'items-start'
          : column.vertical_align === 'BOTTOM'
          ? 'items-end'
          : ''
      }`}
      style={{
        width: `${column.size}px`,
        fontSize: `${((column.font?.size || 14) * zoom) / 100}px`,
        color: `${column.font?.color || '#16192C'}`,
        fontFamily: `${column.font?.name || 'Poppins'}`,
        lineHeight: `${column.font?.line_height || 1.4}`,
        ...getFontFamily(column?.font?.style, column?.font?.name),
        ...getAlignment(column.alignment),
        paddingTop: column.padding?.top,
        paddingRight: column.padding?.right,
        paddingBottom: column.padding?.bottom,
        paddingLeft: column.padding?.left,
        borderTop: column.border?.top,
        borderRight: column.border?.right,
        borderBottom: column.border?.bottom,
        borderLeft: column.border?.left,
      }}>
      <label style={{}}>{column.text}</label>
    </div>
  );
};

const TableElementWrapper = styled('div')`
  width: 100%;
  .input-element {
    height: 100%;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.colors.border};
    outline: none;
    padding-top: 0px;
    padding-bottom: 0px;

    &:hover {
      // border: 1px solid ${({ theme }) => theme.colors.zervioBlueSecondary};
    }

    &:focus {
      // border: 1px solid ${({ theme }) => theme.colors.zervioBlue};
    }

    &::placeholder {
      opacity: 0.3;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .textarea-element {
    min-height: 40px;
    /* max-height: 500px; */
    resize: none;
    border-radius: 18px;
    border: 1px solid ${({ theme }) => theme.colors.ZenGraySecondary};
  }

  .input-error {
    border-color: ${({ theme }) => theme.colors.ZenNegative};

    &:hover {
      border-color: ${({ theme }) => theme.colors.ZenNegative};
    }

    &:focus {
      border-color: ${({ theme }) => theme.colors.ZenNegative};
    }
  }
`;

export default TableElement;
